module.exports = __webpack_public_path__ + "img/pinterest-b.2c60719d.svg";